import React from 'react';
import moment from 'moment';
import { FaBriefcase, FaCalendarAlt } from 'react-icons/fa';
import { FiLayers } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import Wrapper from '../assets/wrappers/Nft';
import Info from './Info';
import { truncateMessage } from '../utils/textUtils';
import { useDispatch } from 'react-redux';
import { setId } from '../features/editor/editorSlice';
import { deleteText, validateText } from '../features/text/textSlice';
import { Types } from 'mongoose';
const Text = ({ _id, title, text }) => {
  const dispatch = useDispatch();
  const date = moment(Types.ObjectId(_id).getTimestamp()).format(
    'MMM Do, YYYY'
  );
  return (
    <Wrapper>
      <header>
        <div className='main-icon'>{title[0]}</div>
        <div className='info'>
          <h5>{title}</h5>
          <p>{truncateMessage(text, 100)}</p>
        </div>
      </header>
      <div className='content'>
        <div className='content-center'>
          <Info icon={<FaCalendarAlt />} text={`Started: ${date}`} />
          <Info icon={<FiLayers />} text={`${text.length} characters`} />
          <Info icon={<FaBriefcase />} text={`${_id}`} />
        </div>
        <footer>
          <div className='actions'>
            <Link to='/editor'>
              <button
                className='btn edit-btn'
                onClick={() => dispatch(setId({ id: _id }))}
              >
                Edit
              </button>
            </Link>
            <button
              className='btn edit-btn'
              onClick={() => dispatch(validateText({ id: _id }))}
            >
              Validate
            </button>
            <button
              className='btn delete-btn'
              onClick={() => dispatch(deleteText({ id: _id }))}
            >
              Delete
            </button>
          </div>
        </footer>
      </div>
    </Wrapper>
  );
};

export default Text;
